import { AppDispatch } from '../redux/store';
import { adaptLogoutAll } from '../redux/authAdapter';
import { showError } from '../utils/alert';
import {
    ApiErrorType,
    isApiError,
    isErrorType,
    getUserErrorMessage,
} from './apiErrors';

export const handleApiError = (
    error: unknown,
    dispatch: AppDispatch,
    navigate: (path: string) => void
): string | void => {
    if (!isApiError(error)) {
        showError('Something went wrong');
        return;
    }

    if (isErrorType(error, ApiErrorType.UNAUTHORIZED)) {
        dispatch(adaptLogoutAll() as any);
        navigate('/login');
        return;
    }

    if (isErrorType(error, ApiErrorType.FORBIDDEN)) {
        console.warn('[403 Forbidden]', error.message);
        return;
    }

    if (isErrorType(error, ApiErrorType.VALIDATION)) {
        return getUserErrorMessage(error);
    }

    if (
        isErrorType(error, ApiErrorType.NETWORK) ||
        isErrorType(error, ApiErrorType.TIMEOUT)
    ) {
        showError(getUserErrorMessage(error) + ' - Please try again');
        return;
    }

    if (isErrorType(error, ApiErrorType.RATE_LIMIT)) {
        showError(getUserErrorMessage(error));
        return;
    }

    if (isErrorType(error, ApiErrorType.SERVER_ERROR)) {
        showError('Server error - please try again later');
        return;
    }

    if (isErrorType(error, ApiErrorType.NOT_FOUND)) {
        showError(getUserErrorMessage(error));
        return;
    }

    if (isErrorType(error, ApiErrorType.CONFLICT)) {
        showError(getUserErrorMessage(error));
        return;
    }

    showError(getUserErrorMessage(error) || 'Something went wrong');
};
export const createErrorHandler = (
    dispatch: AppDispatch,
    navigate: (path: string) => void
) => {
    return (error: unknown): string | void => {
        return handleApiError(error, dispatch, navigate);
    };
};

export const createErrorMatcher = (...types: ApiErrorType[]) => {
    return (error: unknown): boolean => {
        if (!isApiError(error)) return false;
        return types.includes(error.type);
    };
};
export const silentErrorHandler = (
    error: unknown,
    context?: string
): void => {
    if (isApiError(error)) {
        console.warn(
            `[Silent Error${context ? ': ' + context : ''}] ${error.type}:`,
            error.message
        );
    } else {
        console.warn(
            `[Silent Error${context ? ': ' + context : ''}]`,
            error
        );
    }
};
